export enum Sizes {
    sm = "sm",
    md = "md",
    lg = "lg",
}
